import { Loader } from '@googlemaps/js-api-loader'

class gMap {
  constructor() {
    const apiOptions = {
      apiKey: 'AIzaSyAW6waxpTzNaDkcORIBoQfL4HboG7Dy7Zc',
    }

    const loader = new Loader(apiOptions)

    loader.load().then(() => {
      console.log('Loaded!')
      displayMap()
    })

    function displayMap() {
      const coords = { lat: 40.04320101900118, lng: -75.36565882883642 }
      const mapOptions = {
        // 40.04320101900118, -75.36565882883642
        center: coords,
        zoom: 14,
        mapId: 'f2bbe81f73042b31',
      }

      const mapDiv = document.getElementById('g-map')
      const map = new google.maps.Map(mapDiv, mapOptions)
      const marker = new google.maps.Marker({
        position: coords,
        map: map,
        title: 'Marker Title',
      })

      return map
    }
  }
}

export default gMap
